<nz-result nzStatus="404" nzTitle="404" nzSubTitle="Sorry, the page you visited does not exist.">
  <div nz-result-extra>
    <button nz-button nzType="primary" (click)="navigationHome()" class="btn-back-home">
      <span nz-icon nzType="home" nzTheme="outline"></span>Back Home
    </button>
  </div>
</nz-result>
